// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3CCGY","label":"Labeled_label__3M-0W","divider":"Labeled_divider__Xx8ib"};